import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { AddUploadedFile, UploadCustomerSupportFile } from "@edp-store/actions/file-upload.actions";
import { Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { environment } from "@edp-environments/environment";
import { getMimeType } from "@edp-utils/get-mimetype.utils";

const argsContentRep = {
    prod: "CP",
    dev: "CQ",
};

@Component({
    selector: "energetic-certification-autodeclaration",
    templateUrl: "./energetic-certification-autodeclaration.component.html",
    styleUrls: ["./energetic-certification-autodeclaration.component.scss"],
})
export class EnergeticCertificationAutodeclarationComponent implements OnInit {
    @Input() argsFileGas: { certification: string; declaration: string };
    public fieldFileToToSet = "ArchObj";
    public valueFileToSetCertification = "";
    public valueFileToSetDeclaration = "";

    private isProduction = false;

    constructor(private store: Store<IAppState>) {}

    public ngOnInit(): void {
        this.isProduction = !!environment.production;
        this.valueFileToSetCertification = this.argsFileGas.certification;
        this.valueFileToSetDeclaration = this.argsFileGas.declaration;
    }

    public onUploadFile(event) {
        const id = Date.now();
        const mimeType = getMimeType(event.name);

        const argsDefaultGas = {
            mimeType,
            id,
            ContentRep: this.isProduction ? argsContentRep.prod : argsContentRep.dev,
            AdditionalObjects: [{ name: "RECEPTDATE", value: moment().format("YYYYMMDD") }],
        };

        this.store.dispatch(new AddUploadedFile({ ...event, ...argsDefaultGas }));

        this.store.dispatch(
            new UploadCustomerSupportFile({
                name: event.name,
                size: event.size,
                base64: event.file,
                modified: null,
                error: null,
                ...argsDefaultGas,
            })
        );
    }
}
